export enum MobileMessageTypes {
    Both = 1,
    Mobile = 2,
    Email = 3,
}
